import React from 'react';
import PropTypes from 'prop-types';

import { Icon, Status } from '@weezevent/nacre';
import Styles from '../../styles/minisite/blocks.module.css';

export default function BlockCard({ children, statusProps, mini, title, icon, onClick, disabled }) {
    return (
        <div
            className={`${Styles['card-block']}${mini ? ` ${Styles['card-block-mini']}` : ''}${disabled ? ` ${Styles['card-block-disabled']}` : ''}`}
            onClick={!disabled ? onClick : null}
        >
            <div className={Styles['card-block-container']}>
                {!mini ? (
                    <div className={Styles['card-block-icon']}>
                        <Icon name={icon} size="huge" />
                    </div>
                ) : (
                    <Icon name={icon} size="huge" />
                )}
                <div className={Styles['card-block-content']}>
                    <div className={Styles['card-block-title']}>
                        {title} {statusProps && <Status className={Styles['card-block-status']} {...statusProps} />}
                    </div>
                    {children && <div className={Styles['card-block-text']}>{children}</div>}
                </div>
            </div>
        </div>
    );
}

BlockCard.propTypes = {
    icon: PropTypes.string.isRequired,
    title: PropTypes.node.isRequired,
    mini: PropTypes.bool,
    disabled: PropTypes.bool,
    children: PropTypes.node,
    statusProps: PropTypes.object
};

BlockCard.defaultProps = {
    mini: false,
    children: null,
    disabled: false,
    statusProps: null
};
